import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

export const Card = forwardRef(function Card({ className, children, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={cn(
        'bg-white border border-ink-200 rounded-xl shadow-sm',
        'dark:bg-ink-900 dark:border-ink-800',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
});

export function CardHeader({ className, children, ...props }) {
  return (
    <div className={cn('px-6 pt-5 pb-4 border-b border-ink-100 dark:border-ink-800', className)} {...props}>
      {children}
    </div>
  );
}

export function CardTitle({ className, children, ...props }) {
  return (
    <h3 className={cn('text-base font-semibold text-ink-900 dark:text-ink-50 tracking-tightish', className)} {...props}>
      {children}
    </h3>
  );
}

export function CardDescription({ className, children, ...props }) {
  return (
    <p className={cn('text-sm text-ink-500 dark:text-ink-400 mt-1', className)} {...props}>
      {children}
    </p>
  );
}

export function CardBody({ className, children, ...props }) {
  return (
    <div className={cn('px-6 py-5', className)} {...props}>
      {children}
    </div>
  );
}

export function CardFooter({ className, children, ...props }) {
  return (
    <div className={cn('px-6 py-4 border-t border-ink-100 dark:border-ink-800 bg-ink-50/50 dark:bg-ink-800/30 rounded-b-xl', className)} {...props}>
      {children}
    </div>
  );
}

export default Card;
